import { fonts, fontWeights } from '../utils/theme';
const { fallback } = fonts;
const { light, medium, bold } = fontWeights;
export default {
    display1: {
        fontFamily: [fonts.black, fallback].join(', '),
        fontStyle: 'normal',
        fontWeight: bold,
        fontSize: '2rem',
        lineHeight: '2.25rem',
    },
    display2: {
        fontFamily: [fonts.black, fallback].join(', '),
        fontStyle: 'normal',
        fontWeight: bold,
        fontSize: '1.5rem',
        lineHeight: '1.75rem',
    },
    display3: {
        fontFamily: [fonts.black, fallback].join(', '),
        fontStyle: 'normal',
        fontWeight: bold,
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
    },
    display4: {
        fontFamily: [fonts.medium, fallback].join(', '),
        fontStyle: 'normal',
        fontWeight: medium,
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
    },
    display5: {
        fontFamily: [fonts.medium, fallback].join(', '),
        fontStyle: 'normal',
        fontWeight: medium,
        fontSize: '1rem',
        lineHeight: '1.5rem',
    },
    display6: {
        fontFamily: [fonts.medium, fallback].join(', '),
        fontStyle: 'normal',
        fontWeight: medium,
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
    },
    mainCopy: {
        fontFamily: [fonts.light, fallback].join(', '),
        fontStyle: 'normal',
        fontWeight: light,
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
    },
    smallCopy: {
        fontFamily: [fonts.light, fallback].join(', '),
        fontStyle: 'normal',
        fontWeight: light,
        fontSize: '0.75rem',
        lineHeight: '1.25rem',
    },
};
